const initializePricingForms = () => {
  document.querySelectorAll('[data-pricing-form]').forEach((form) => {
    form.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-add-pricing-row]');
      if (addButton) {
        const type = addButton.dataset.addPricingRow;
        const container = form.querySelector(`[data-pricing-rows="${type}"]`);
        const template = form.querySelector(`[data-pricing-template="${type}"]`);
        // Rails treats hashes with numeric keys as nested form collections.
        const index = `${Date.now()}${container.children.length}`;
        container.insertAdjacentHTML('beforeend', template.innerHTML.replace(/NEW_INDEX/g, index));
        return;
      }

      const removeButton = event.target.closest('[data-remove-pricing-row]');
      if (removeButton) removeButton.closest('[data-pricing-row]').remove();
    });
  });
};

document.addEventListener('DOMContentLoaded', initializePricingForms);
